export const initialState = {
    foodItems: null,
    showCart: false,
    cartItems: [],
    cartTotal: 0,
    checkoutData: {},
    userCartInfo: {
        address: "",
        apartments: "",
        entrance: "",
        floor: "",
        intercom: "",
        paymentMethod: "",
        phone: "",
        username: "",
        orderType: "delivery",
        comment: "",
        agreement: false
    },
    cookieAccept: false,
    payment: {
        uniteller_shop_idp: "",
        uniteller_order_idp: "",
        uniteller_customer_idp: "",
        uniteller_subtotal_p: "",
        uniteller_lifetime: "",
        uniteller_signature: "",
        uniteller_url_return_ok: "",
        uniteller_url_return_fail: "",
    },
    verificationCode: ""
}